export enum CompanyAddressFormPropsEnum {
  IMAGE_ALT = 'Carbon one',
  PAGE_TITLE = 'Company Address',
  BUTTON_LABEL_SUBMIT = 'Create',
  BUTTON_LABEL_BACK = 'Back',
  DROPDOWN_LABEL = 'Long Label: ',
  ADDRESSABLE_TYPE  = 'company'
}